/* global $get:writable */
/* global PDFReportService */
/* global require */
/* exported _mutex_slap */

//***
//*** PDFJob
//***

const _ = require('lodash');
const Cookies = require('js-cookie');
const efwTurnstile = require('./efw.turnstile');   // token()/reset()/mount() for the PDF email gate

function Bindable() {
}

Bindable.prototype.Bind = function(fnMethod) {
    var me = this;
    return (function() {
        return (fnMethod.apply(me, arguments));
    }
    );
}

function IsIE() {
    return ((navigator.appVersion.toLowerCase().indexOf("msie") != -1) && !window.opera);
}

// ...in case we don't have MS library
if ("undefined" == typeof $get) {
    window.$get = function(s) {
        var $g = jQuery("#" + s);
        return ($g.length > 0 ? $g[0] : null);
    }
}

//
// Little progress-bar plugin
// 
(function ($) {
    $(document).ready(function () {
        const _ = require('lodash');
        $.fn.progressBar = function (options) {
            var init = function (opts) {
                var $bar = $('<div class="progress"><div class="progress-bar progress-bar-striped" role="progressbar" style="width: 0;" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"></div></div>');
                $bar.css('width', opts.width + 'px');
                $(this).append($bar);
            },
                update = function (pct) {
                    $(this).find('.progress-bar').css('width', pct + '%').attr('aria-valuenow', pct);
                };
            return $(this).each(function () {
                if (typeof (options) === 'object')
                    _.bind(init, this)(options);
                else
                    _.bind(update, this)(options);
            });
        };
    });
})(jQuery);

// constructor
PDFJob.prototype = new Bindable();

// link, cancel, ready, dim
PDFJob.InterfaceKeys = ["_l_", "_x_", "_r_"];

function PDFJob(strKey, strSpecUrl, strErrorUrl, aKeys) {
    this.ClientID = PDFJob.getClientID();
    this.Key = strKey || '';
    this.SpecUrl = strSpecUrl || '';
    this.ErrorUrl = strErrorUrl || '';
    this.Ticks = 0;
    this.LastProgress = 0;
    this.Cancelled = false;
    this.JobID = "xxx";
    this.Keys = aKeys;
    this.InterfaceNames = new Array();
    this.InterfaceElements = new Array();
    this.LinkButton = jQuery("#_lb_" + this.Key.toLowerCase());
    if (this.LinkButton)
        this.LinkClick = this.LinkButton.onclick;

    for (var i = 0; i < PDFJob.InterfaceKeys.length; i++) {
        this.InterfaceNames[i] = PDFJob.InterfaceKeys[i] + this.Key.toLowerCase();
        this.InterfaceElements[i] = $get(this.InterfaceNames[i]);
    }

    this.createClick = function() {
        // ignore premature clicks.
        if (KillClicks)
            return;

        // kill multiple clicks.
        if (this.LinkButton)
            this.LinkButton.onclick = null;

        PDFJob.Debounce();
        this.create();
    }

    this.create = function() {
        // try to get ready-made report if it's there.
        //        console.log("create");
        if (this.loadCache())
            return;
        PDFReportService.Create(this.ClientID, this.SpecUrl, this.Bind(function(result) { this.CreateSuccess(result); }), this.Bind(function(result) { this.CreateFailure(result); }));
        // generate Google Analytics event tracking
        if (window.gtag) {
            window.gtag('event', 'Clicks', { action: 'PDFReport', label: 'create' });
        } else {
            window._gaq && window._gaq.push(['_trackEvent', 'Clicks', 'PDFReport', 'create']);
        }
    }


    this.CreateSuccess = function(result) {
        //        console.log("CreateSuccess");
        this.JobID = result;
        // save the value away for future use
        var j = $get("_j_" + this.Key.toLowerCase());
        if (j)
            j.value = result;
        // bind cancel function to button
        var b = $get("_xb_" + this.Key.toLowerCase());
        if (b)
            b.onclick = this.Bind(function() { this.cancelClick(); });
        this.showCancel();
        this.startTimer();
        this.updateProgress(5);
    }

    this.CreateFailure = function(/* result */) {
        PDFJob.goErrorPage("CreateFailure");
    }

    this.startTimer = function() {
        this.Timer = setInterval(this.Bind(function() { this.timerTick() }), 3000);
    }

    this.timerTick = function() {
        this.Ticks = this.Ticks + 1;
        if (this.Ticks > 30) {  // timeout.
            this.cancelJob();
            PDFJob.goErrorPage("Timeout");
            return;
        }
        if (this.Cancelled)
            return;
        this.progress();
    }

    this.progress = function() {
        //var key = this.Key;
        PDFReportService.Progress(this.JobID, this.Bind(function(result) { this.ProgressSuccess(result); }), this.Bind(function(result) { this.ProgressFailure(result); }));
    }

    this.ProgressSuccess = function(result) {
        if (this.Cancelled)
            return;
        if (result > 0)
            this.updateProgress(result);
        if (result == 100) {
            this.finish();
            return;
        }
        if (result >= 0)    // anything's good
        {
            if (result != this.LastProgress)
                this.Ticks = 0; // reset timeout; we're getting somewhere.
            this.LastProgress = result;
            return;
        }

        PDFJob.goErrorPage("FailureToProgress(" + result + ")");
    }

    this.ProgressFailure = function(/* result */) {
        if (this.Cancelled)
            return;
        this.cancelInterface();
        PDFJob.goErrorPage("ProgressFailure");
    }

    this.finish = function() {
        this.killTimer();
        this.showReady();
        PDFReportService.ReportUrl(this.JobID, this.ErrorUrl, this.Bind(function(result) { this.ReportUrlSuccess(result); }), this.Bind(function(result) { this.ReportUrlFailure(result); }));
    }

    this.ReportUrlSuccess = function(result) {
        if (result) {
            var s = $get("_v_" + this.Key.toLowerCase());
            if (s)
                s.value = result;       // in case we need it later.
            // bind download function to ready button
            var b = $get("_rb_" + this.Key.toLowerCase());
            if (b)
                b.onclick = this.Bind(function() { this.loadCache(); });

            // IE blocks this functionality. Grrr
            if (!IsIE())
                window.location = result;   // will load the PDF

            // also...show the email interface...
            jQuery("#_m_" + this.Key.toLowerCase()).show();

            // mount Turnstile only now that the email form is revealed (report can take a while —
            // mounting at page-load would let the token go stale before the user can submit).
            efwTurnstile.mount(jQuery("#_m_captcha_" + this.Key.toLowerCase())[0]);

            // ...hide the menu-list...
            jQuery("#_t_" + this.Key.toLowerCase()).hide();

            // bind sendMail function to send button.
            jQuery("#_mb_" + this.Key.toLowerCase()).bind('click', this.Bind(function() { this.sendMail(); return false; }));

            // light up the watermarks
            if (jQuery.watermark) jQuery.watermark.showAll();
            
            return;
        }
        // otherwise...
        PDFJob.goErrorPage("ReportUrlSuccess");
    }

    this.ReportUrlFailure = function(/* result */) {
        this.cancelInterface();
        PDFJob.goErrorPage("ReportUrlFailure");
    }

    this.cancelJob = function() {
        var key = this.Key;
        if (key == "xxx")
            return; // ignore cancellations before job is fully created!
        this.Key = "xxx";   // prevent double-clicks.
        this.killTimer();   // stop asking for status on job we're killing
        this.Cancelled = true;
        PDFReportService.Cancel(this.JobID, this.Bind(function(result) { this.CancelComplete(result); }), this.Bind(function(result) { this.CancelComplete(result); }));
    }

    // cancel button clicked.
    this.cancelClick = function() {
        if (KillClicks)
            return; // ignore premature clicks

        PDFJob.Debounce();
        this.cancelJob();
    }

    // success or failure.
    this.CancelComplete = function(/* result */) {
        this.cancelInterface();
    }

    this.killTimer = function() {
        clearInterval(this.Timer);
    }

    this.showCancel = function() {
        this.showInterface("_x_");
    }

    this.showStart = function() {
        if (this.LinkButton)
            this.LinkButton.onclick = this.LinkClick;
        this.showInterface("_l_");
    }

    this.showReady = function() {
        this.showInterface("_r_");
    }

    // show one of a mutually exclusive list of divs
    this.showInterface = function(strID) {
        for (var i = 0; i < PDFJob.InterfaceKeys.length; i++) {
            if (strID == PDFJob.InterfaceKeys[i]) {
                this.InterfaceElements[i].style.display = "block";
            } else {
                this.InterfaceElements[i].style.display = "none";
            }
        }
    }

    this.cancelInterface = function() {
        this.killTimer();
        this.updateProgress(0);
        this.showStart();
    }

    this.loadCache = function() {
        var s = $get("_v_" + this.Key.toLowerCase());
        if (s && s.value && s.value.length > 0) {
            window.location = s.value;
            return true;
        }
        return false;
    }

    this.updateProgress = function(i) {
        var strID = "_p_" + this.Key.toLowerCase();
        jQuery('#' + strID).progressBar(i);
        //var oProgressBar = $get(strID);
        //if (myJsProgressBarHandler && oProgressBar) {
        //        myJsProgressBarHandler.setPercentage(strID, i.toString());
        //}
    }

    this.sendMail = function() {
        var key = this.Key;
        if (key == "xxx")
            return; // ignore mail requests before job is fully created!

        var to = jQuery('#_m_to_' + this.Key.toLowerCase());
        var from = jQuery('#_m_from_' + this.Key.toLowerCase());

        // validate proximate form
        var toValid = to.valid();
        var fromValid = from.valid();

        if (!toValid || !fromValid)
            return false;

        var subject = jQuery('#_m_subject_' + this.Key.toLowerCase()).val();
        var message = jQuery('#_m_message_' + this.Key.toLowerCase()).val();

        // Turnstile token, if the widget produced one (interaction-only usually resolves silently).
        // SOFT-FAIL: send even when the widget can't produce a token (not-loaded = Cloudflare api.js
        // blocked; error-* = challenge failed; unsolved). pdfshare is a rare, deep, zero-bot-signal
        // operation gated by a real JobID — stranding a finished report because the widget won't
        // load/verify is the wrong trade. The beacon still records the failure + reason (so the
        // widget health stays visible), and the server gate softpasses an ABSENT token for pdfshare
        // while still rejecting a present-but-invalid one.
        var $slot = jQuery('#_m_captcha_' + this.Key.toLowerCase());
        var tsToken = efwTurnstile.token($slot[0]);
        efwTurnstile.beacon(null, tsToken ? 'solved' : 'failed', 'pdfshare', $slot[0]);
        PDFReportService.SendMail(this.JobID, to.val(), from.val(), subject, message, tsToken || '', this.Bind(function(result) { efwTurnstile.reset($slot[0]); this.MailSuccess(result); }), this.Bind(function(result) { efwTurnstile.reset($slot[0]); this.MailFailure(result); }));
        // record the sending event for google analytics
        if (window.gtag) {
            window.gtag('event', 'Clicks', { action: 'PDFReport', label: 'send' });
        } else {
            window._gaq && window._gaq.push(['_trackEvent', 'Clicks', 'PDFReport', 'send']);
        }
    }

    this.MailSuccess = function(/* result */) {
        jQuery('#_m_failure_' + this.Key.toLowerCase()).hide();
        jQuery('#_m_success_' + this.Key.toLowerCase()).show();
    }

    this.MailFailure = function(/* result */) {
        jQuery('#_m_failure_' + this.Key.toLowerCase()).show();
        jQuery('#_m_success_' + this.Key.toLowerCase()).hide();
    }
}

// class functions
PDFJob.getClientID = function() {
    var o = $get("_cid");
    return (o ? o.value : "");
}

PDFJob.goErrorPage = function(x) {
    //    console.log("goErrorPage(" + x + ")");
    var o = $get("_eurl");
    if (o) {
        var s = o.value;
        if (x)
            s = s + "&_x=" + x;  // optional error flag
        window.location = s;
    }
}

// debounce rapid clicks.
var KillClicks = false;
var ClickTimer = -1;

PDFJob.Debounce = function() {
    PDFJob.ClearDebounce();
    ClickTimer = setInterval("PDFJob.EndDebounce()", 500);
    //    console.log("Debounce");
    KillClicks = true;
}

PDFJob.EndDebounce = function() {
    PDFJob.ClearDebounce();
    KillClicks = false;
    //    console.log("EndDebounce");
}

PDFJob.ClearDebounce = function() {
    if (ClickTimer >= 0) {
        clearInterval(ClickTimer);
        ClickTimer = -1;
    }
}

PDFJob.start = function(strKey, strSpecUrl, strErrorUrl, aKeys) {
    var j = new PDFJob(strKey, strSpecUrl, strErrorUrl, aKeys);
    j.createClick();
}

var PDFJOBAUTOSTART_KEY = '_pdf_job_';

PDFJob.autoStart = function (opts) {
    console.log('PDFJob.autoStart: ' + opts);
    var jobId = '';
    // don't run the report again if already in progress
    var c = Cookies.get(PDFJOBAUTOSTART_KEY + opts.sessionID);
    if (!c) {
        var cloneSessionCall = window.location.toString().replace(/([^?]*)\?(.*)/, '$1/CloneForPDFReport?$2');
        jQuery.ajax({
            cache: false,
            type: 'POST',
            url: cloneSessionCall,
            data: '{ "key": "' + opts.key + '" }',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (result /*, textStatus, jqXHR */) {
                console.log("PDFJob.autoStart: " + JSON.stringify(result));
                var url = JSON.parse(result.d).url + '&k=' + opts.key;
                PDFReportService.CreateWithUpload(
                    opts.clientID,
                    url,
                    window.logon$services.vaultService,
                    jQuery.fn.logon$getToken && jQuery.fn.logon$getToken(),
                    opts.fileName,
                    opts.crmClientID,
                    opts.crmUserID,
                    Cookies.get('_vsid') || '',
                    function (result) {
                        jobId = result;
                        console.log('Started job ' + jobId);
                        Cookies.set(PDFJOBAUTOSTART_KEY + opts.sessionID, { jobId: jobId, time: new Date(), sessionId: opts.sessionID }, { path: '/' });
                        if (jQuery.gevent) {
                            // notify the user.
                            jQuery.gevent.publish('efw.result', { title: 'vault.notify.upload.title', message: 'vault.notify.upload.message', timeout: 10 * 1000 });
                        }
                    }, function (result) {
                        console.log('Error starting job: ' + result);
                    }
                );
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error("Error in PDFJob.autoStart: " + textStatus + ": " + errorThrown);
            }
        });
    }
};

// ...finally, expose as a global variable to be called from outside the bundle.
window.PDFJob = PDFJob;

//
// END PDFJob
//

// validation support
jQuery.validator.addMethod("dateRange", function(value, element, params) {
    if (this.optional(element))
        return true;

    // find related month
    var oMonth = jQuery(params[0]);

    if (this.optional(oMonth[0]))
        return true;

    var mm = parseInt(oMonth.val(), 10);
    if (isNaN(mm) || 0 == mm)
        mm = 1;
    var yyyy = parseInt(value, 10);
    var dd = 1;

    var dVal = new Date(yyyy, mm - 1, dd);

    if (dVal.getFullYear() != yyyy || dVal.getMonth() != mm - 1 || dVal.getDate() != dd)
        return false;

    var dMin = new Date(params[1]);
    var dMax = new Date(params[2]);

    var ms = dVal.getTime();

    return (ms >= dMin.getTime() && ms <= dMax.getTime());
},
    jQuery.validator.format("Please enter a date between {1} and {2}.")   // localized in the calling control.
);

jQuery.validator.addMethod("dateBefore", function(value, element, params) {
    if (this.optional(element))
        return true;

    // find related month
    var oMonth = jQuery(params[0]);

    if (this.optional(oMonth[0]))
        return true;

    var mm = parseInt(oMonth.val(), 10);
    if (isNaN(mm) || 0 == mm)
        mm = 1;
    var yyyy = parseInt(value, 10);
    var dd = 1;

    var dVal = new Date(yyyy, mm - 1, dd);

    if (dVal.getFullYear() != yyyy || dVal.getMonth() != mm - 1 || dVal.getDate() != dd)
        return false;

    var dMax = new Date(params[1]);

    var ms = dVal.getTime();

    return (ms <= dMax.getTime());
},
    jQuery.validator.format("Please enter a date on or before {1}.")
);

jQuery.validator.addMethod("dateAfter", function(value, element, params) {
    if (this.optional(element))
        return true;

    // find related month
    var oMonth = jQuery(params[0]);

    if (this.optional(oMonth[0]))
        return true;

    var mm = parseInt(oMonth.val(), 10);
    if (isNaN(mm) || 0 == mm)
        mm = 1;
    var yyyy = parseInt(value, 10);
    var dd = 1;

    var dVal = new Date(yyyy, mm - 1, dd);

    if (dVal.getFullYear() != yyyy || dVal.getMonth() != mm - 1 || dVal.getDate() != dd)
        return false;

    var dMin = new Date(params[1]);

    var ms = dVal.getTime();

    return (ms >= dMin.getTime());
},
    jQuery.validator.format("Please enter a date on or after {1}.")
);

//
// Mutex jQuery functions
// 
(function ($) {
    $.mutex = {
        data: {},

        add: function (k, v) {
            this.data[k] = v;
        },

        slap: function (strMutex, strID) {
            if (!jQuery('#' + strID).is(':checked'))
                return;
            var $c = jQuery('[mutex=' + strMutex + ']:not(#' + strID + '):checked');
            var $c0 = jQuery('[mutex0=' + strMutex + ']:not(#' + strID + '):not(:checked)');
            var a = ($c.length + $c0.length > 0);
            $c.prop('checked', false).trigger('change');
            $c0.prop('checked', true);
            if (a && this.data[strMutex]) {
                this.alert(strMutex, this.data[strMutex]);
            }
        },

        alert: function (strMutex, strText) {
            if (Cookies.get(strMutex))
                return;
            alert(strText);
            Cookies.set(strMutex, 'true');
        }
    };
})(jQuery);

//
// Bootstrap-modal confirmation
// 
(function ($) {
    const ID = require('./efw.id');

    $.efw$confirm = function (text, options, callback) {
        let /* opts = options, */
            id = ID(),
            $dlg = $(
`<div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" aria-labelledby="${id}" aria-describedby="${id}_body">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="${id}">${'general.ui.confirm'._local()}</h5>
            </div>
            <div class="modal-body" id="${id}_body">
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary cancel">${'general.ui.cancel'._local()}</button>
                <button type="button" class="btn btn-default btn-primary ok">${'general.ui.ok'._local()}</button>
            </div>
        </div>
    </div>
</div>`);
        
        $dlg.find('.modal-body').text(text);
        console.log('efw$confirm: ' + text);

        // handle button clicks
        $dlg.find('.cancel').on('click', function (e) {
            e.preventDefault();
            callback(false);
            $dlg.modal('hide');
            return false;
        });

        $dlg.find('.ok').on('click', function (e) {
            e.preventDefault();
            callback(true);
            $dlg.modal('hide');
            return false;
        });

        $dlg.on('hidden.bs.modal', function () {
            $dlg.modal('dispose');
        });

        $dlg.efw$dialogAccessabilityRetrofit();

        $dlg.modal('show');
    }
})(jQuery);

//
// Assertion jQuery functions
// 
(function ($) {
    const c_strFormID = "_f8_main";
    const c_strBtnSubmit = "#btnSubmit";

    $.assert = {
        data: {},

        add: function (a) {
            this.data[a.key || 'no-key'] = a;
        },

        trigger: function (key) {
            var a = this.data[key];
            if (!a)
                return;
            if (!a.message && !a.info)
                return;
            var $override;
            if (a.override)
                $override = jQuery('#' + a.override);
            if ($override && 'true' == $override.val()) {
                console.log('Overriding failed assertion.');
                return;
            }
            if (typeof (a.info) != 'undefined' && a.info.length > 0) {
                // vb only
                $override.val('true');
                jQuery('#' + a.info).bind('dialogclose', function (/* event */) {
                    jQuery('#' + c_strFormID).find(c_strBtnSubmit).trigger('click');
                });
                jQuery('#' + a.info).logon$open();
                return;
            }
            var $escaped = jQuery('<div />').html(a.message).text(); // remove html encoding
            $.efw$confirm($escaped, {}, function (confirmed) {
                if (confirmed) {
                    console.log('confirm: true');
                    if ($override)
                        $override.val('true');
                    jQuery('#' + c_strFormID).find(c_strBtnSubmit).trigger('click');
                } else {
                    console.log('confirm: false');
                    if ($override)
                        $override.val('false');
                }
            });
        }
    }
})(jQuery);

// support for conditionally enabling questions
function qEnable(strKey) { // eslint-disable-line no-unused-vars
    var strTarget = '.styleQuantityRow_' + strKey;
    if (jQuery(strTarget).qEnable) {
        jQuery(strTarget).qEnable();
    }
    else {
        jQuery(strTarget).removeClass('styleQuantityRowDisabled').find('input').each(
        function(/* i */) {
            var o = jQuery(this).data('xrules');
            if (o && o.required) {
                jQuery(this).rules('add', { required: true });
            }
        }
    ).prop('disabled', false);
    }
    jQuery('.styleRequiredFieldIcon', strTarget).fadeIn('slow');
}

function qDisable(strKey) { // eslint-disable-line no-unused-vars
    var strTarget = '.styleQuantityRow_' + strKey;
    if (jQuery(strTarget).qEnable) {
        jQuery(strTarget).qEnable();
    }
    else {
        jQuery(strTarget).addClass('styleQuantityRowDisabled').find('input').each(
        function(/* i */) {
            var o = jQuery(this).data('xrules');
            if (o && o.required) {
                jQuery(this).rules('remove', 'required');
            }
        }
    ).prop('disabled', true);
    }
    jQuery('.styleRequiredFieldIcon', strTarget).fadeOut('slow');
}

// support for auto-tabbing to next input field when maxlength characters entered
(function ($) {
    $.qTab = function (event) {
        // the keycode for the key evoking the event
        var keyCode = event.which;
        // we want to ignore the following keys:
        // 9 Tab, 16 Shift, 17 Ctrl, 18 Alt, 19 Pause Break, 20 Caps Lock
        // 27 Esc, 33 Page Up, 34 Page Down, 35 End, 36 Home
        // 37 Left Arrow, 38 Up Arrow, 39 Right Arrow, 40 Down Arrow
        // 45 Insert, 46 Forward Delete, 144 Num Lock, 145 Scroll Lock
        var ignoreKeyCodes = ',9,16,17,18,19,20,27,33,34,35,36,37,38,39,40,45,46,144,145,';
        if (ignoreKeyCodes.indexOf(',' + keyCode + ',') > -1) { return; }

        // we want to ignore the backspace on keydown only
        // let it do its job, but otherwise don't change focus
        if (keyCode == 8 && event.type == 'keydown') { return; }

        var $this = jQuery(this);
        var currentLength = $this.val().length;
        var maximumLength = $this.attr('maxlength');
        var tabTo = $this.attr('tabto');
        //var tabFrom = $this.attr('tabfrom');
        var monthFormat = $this.attr('monthformat');

        // if backspace key and there are no more characters, go back
        //    if (keyCode == 8 && currentLength == 0 && tabFrom && tabFrom.length > 0) {
        //        jQuery('#' + tabFrom).focus();
        //    }

        // advance the field only on keyup
        if (event.type == 'keyup') {
            // if we've filled up this input, go to the next
            if (currentLength == maximumLength && tabTo && tabTo.length > 0) {
                jQuery('#' + tabTo).focus();
            }

            // also, advance if the month field is clearly full.
            if (monthFormat) {
                var nMonth = parseInt($this.val());
                if (!isNaN(nMonth)) {
                    if (nMonth > 1) {
                        jQuery('#' + tabTo).focus();
                    }
                }
            }
        }
    }
}(jQuery));

//
// Enabler plugin
//

(function ($) {
    var groups = new Array();
    var methods = {
        init: function() {
            return this.each(function() {
                // bundle data on the root
                if (!$(this).data('enabler'))
                    $(this).data('enabler', { 'enableValue': !$(this).attr('disabled') });  // true
            });
        },
        addToGroup: function(grp) {
            var $grp = groups[grp] || new Array();
            $grp.push($(this));
            groups[grp] = $grp;
        },
        getParent: function() { // returns a selector, not an object
            var $data = $(this).data('enabler');
            if (!$data)
                return null;
            return $data.parent;
        },
        getParents: function() { // returns array of selectors
            var $data = $(this).data('enabler');
            if (!$data)
                return [];
            return $data.parents || [];
        },
        setParent: function(parent) {
            var $data = $(this).data('enabler');
            if (!$data)
                return;
            // Support multiple parents with AND logic
            if (!$data.parents) {
                $data.parents = [];
            }
            if ($data.parents.indexOf(parent) < 0) {
                $data.parents.push(parent);
            }
            $data.parent = parent; // keep for backward compat with chain walking
        },
        getParentGroup: function() { // returns string
            var $data = $(this).data('enabler');
            if (!$data)
                return null;
            return $data.parentGroup;
        },
        setParentGroup: function (grp) {
            var $data = $(this).data('enabler');
            if (!$data)
                return;
            $data.parentGroup = grp;
        },
        getEnableValue: function () {
            var $data = $(this).data('enabler');
            if (!$data)
                return true;
            return $data.enableValue;
        },
        setEnableValue: function(val) {
            var $data = $(this).data('enabler');
            if (!$data)
                return;
            $data.enableValue = val;
        },
        getCoDependents: function() { // returns a selector, not an object
            var $data = $(this).data('enabler');
            if (!$data)
                return null;
            return $data.codependents;
        },
        setCoDependents: function(codependents) {
            var $data = $(this).data('enabler');
            if (!$data)
                return;
            $data.codependents = codependents;
        },
        testEnabled: function () {
            if ($(this).closest('.styleSideBySideDisabledCell').length > 0) {
                return false;   // perma-disabled.
            }
            var $parentGroup = $(this).enabler('getParentGroup');
            if ($parentGroup) {
                // walk the group. Enabled if any returns true.
                var $any = false;
                $.each(groups[$parentGroup], function (i, o) {
                    if (o.enabler('getEnableValue')) {
                        $any = true; return false;
                    }
                });
                return $any;
            } else {
                // Check all parents - ALL must be enabled (AND logic)
                var $parents = $(this).enabler('getParents');
                for (var i = 0; i < $parents.length; i++) {
                    var $parent = $parents[i];
                    // walk this parent's chain
                    while ($parent) {
                        if (!$($parent).enabler('getEnableValue'))
                            return false;
                        $parent = $($parent).enabler('getParent');
                    }
                }
            }
            // nobody stopped us
            return true;
        },
        standardEnable: function() {
            $(this).removeClass('styleQuantityRowDisabled').find('input:not(.sumTotal)').each(
                function() {
                    var o = $(this).data('xrules');
                    if (o && o.required) {
                        $(this).rules('add', { required: true });
                    }
                }
            ).prop('disabled', false);
            $('.styleRequiredFieldIcon', $(this)).fadeIn('slow');
        },
        standardDisable: function() {
            $(this).addClass('styleQuantityRowDisabled').find('input:not(.sumTotal)').each(
                function() {
                    var o = $(this).data('xrules');
                    if (o && o.required) {
                        $(this).rules('remove', 'required');
                    }
                }
            ).prop('disabled', true);
            $(this).find('input:not(.sumTotal):text').val('');
            $(this).find('input:checkbox').prop('checked', false);
            $(this).find('input:radio[value=true]').prop('checked', false);
            $(this).find('input:radio[value=false]').prop('checked', true);
            $(this).trigger('flashDefault');    // controls may implement handlers
            $('.styleRequiredFieldIcon', $(this)).fadeOut('slow');
        }
    };

    $.fn.enabler = function(method) {
        if (methods[method]) {
            // make ready for first use.
            if (!$(this).data('enabler'))
                methods.init.apply(this);
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            // unknown method.
            alert('Unknown method: ' + method.toString());
        }
    };

    $.enabler = {}; // something to hook to

    $.enabler.standardEnableHandler = function(e) {
        if ($(e.target).enabler('testEnabled')) {
            $(e.target).enabler('standardEnable');
        } else {
            $(e.target).enabler('standardDisable');
        }
    };

    $.enabler.showHideEnablerHandler = function(e) {
        var $co = $(e.target).enabler('getCoDependents');
        if ($(e.target).enabler('testEnabled')) {
            $(e.target).show();  //slideDown('slow');
            // also act on codependents
            if ($co && $co.length > 0) {
                jQuery.each($co, function(i, v) {
                    $(v).show();
                });
            }
        } else {
            $(e.target).hide();  //slideUp('slow');
            // also act on codependents
            if ($co && $co.length > 0) {
                jQuery.each($co, function(i, v) {
                    $(v).hide();
                });
            }
        }
    };

    // event support. Hook me
    jQuery.event.special.flashEnable = {
        setup: function(/* data, namespaces */) {
            return false;
        },
        teardown: function(/* namespaces */) {
            return false;
        }
    };
})(jQuery);

//
// S&W side by side fixup 
//
//(function ($) {
//    $(document).ready(function () {
//        $(.siteBy)
//    });
//})(jQuery);

//
// TWMList plugin
//

(function($) {
    var TWMWarning = "";

    $.fn.TWMList = function(options) {
        // merge passed options with defaults
        //var opts = $.extend({}, $.fn.TWMList.defaults, options);

        TWMWarning = options.TWMWarning;

        return this.each(function() {
            init($(this), options);
        });
    };

    function init($obj /*, options */) {
        // bundle data on the root
        var $c = $obj.find('.styleTWMListStatusCount');
        var $l = $obj.find('.styleTWMListStatusList');
        var $d = $obj.find('.styleTWMListData');
        $obj.data('TWMList', { Count: $c, List: $l, Data: $d });

        // hook child checkboxes
        hookChecks($obj);

        // hook clear all button
        $obj.find('a.styleTWMListStatusClear').bind('click', $obj, clearAll);

        // trigger "change" once, to pick up initial values. We need to trigger one per year - looking for January!
        $obj.find('input:checkbox[m-value$=-01]').trigger('change.TWMList');

        // show temporarily hidden wrapper
        $obj.show();
    }

    function hookChecks($root) {
        $root.find('input:checkbox').bind('change.TWMList', $root, buildLists)
    }

    function unhookChecks($root) {
        $root.find('input:checkbox').unbind('change.TWMList');
    }

    function buildLists(e) {
        var $root = e.data;
        var $data = $root.data('TWMList');
        if ($data) {
            // list of all checked boxes.
            var $chk = $root.find('input:checked');
            var iCount = $chk.length;

            if (iCount > 9) {
                // wuh-oh
                alert(TWMWarning);
                unhookChecks($root);
                $(e.target).prop('checked', false);
                e.preventDefault();
                hookChecks($root);
                return;
            }

            if ($data.Count) {
                $data.Count.text(iCount);
                if (iCount == 9) {
                    $data.Count.addClass('styleDialogWarning');
                    // show dependencies if any
                    $(e.target).closest('tr.styleQuantityRow').enabler('setEnableValue', true);
                    $('tr.styleQuantityRow').trigger('flashEnable');
                } else {
                    $data.Count.removeClass('styleDialogWarning');
                    $(e.target).closest('tr.styleQuantityRow').enabler('setEnableValue', false);
                    $('tr.styleQuantityRow').trigger('flashEnable');
                }
            }
            if ($data.List) {
                // encode human-readable list.
                var aHuman = new Array();
                $chk.each(function(/* i */) { aHuman.push($(this).attr('h-value')); });
                $data.List.text(aHuman.join(', '));
                //console.log('data-list calls resize');
                //$root.closest('body').resize(); // trigger body's resize event...in case we're in iFrame
            }
            if ($data.Data) {
                // encode machine-readable list.
                var aData = new Array();
                $chk.each(function(/* i */) { aData.push($(this).attr('m-value')); });
                $data.Data.attr('value', aData.join('|'));
            }

            // list of checked boxes this year.
            var iYear = $(e.target).attr('for-year');
            if (iYear) {
                // count 'em
                if ($root.find('input:checkbox[for-year=' + iYear + ']:checked').length > 0) {
                    // show checkbox icon
                    $root.find('span.styleTWMListCheck[for-year=' + iYear + ']').show();
                } else {
                    $root.find('span.styleTWMListCheck[for-year=' + iYear + ']').hide();
                }
            }
        }
    }

    function clearAll(e) {
        var $root = e.data;

        // unhook change notification
        unhookChecks($root);

        $root.find('input:checked').prop('checked', false);

        // manually update the outputs
        buildLists(e);

        // hide all the checkboxes on tabs
        $root.find('span.styleTWMListCheck').hide();

        // rehook change notification
        hookChecks($root);
    }

    $.fn.TWMList.defaults = {
};
})(jQuery);

// utility function to stop event propagation on all browsers
function stopEvent(e) { // eslint-disable-line no-unused-vars
    if (!e) e = window.event;

    //e.cancelBubble is supported by IE - this will kill the bubbling process.
    e.cancelBubble = true;
    e.returnValue = false;

    //e.stopPropagation works only in Firefox.
    if (e.stopPropagation) {
        e.stopPropagation();
        e.preventDefault();
    }
    return false;
}

// utility function to preload images.
function preload(arrayOfImages) { // eslint-disable-line no-unused-vars
    jQuery(arrayOfImages).each(function() {
        jQuery('<img/>')[0].src = this;
    });
}

// utility function to get URL parameters
function getParameters() { // eslint-disable-line no-unused-vars
    var searchString = window.location.search.substring(1)
    , params = searchString.split("&")
    , hash = {}
    ;

    for (var i = 0; i < params.length; i++) {
        var val = params[i].split("=");
        hash[unescape(val[0])] = unescape(val[1]);
    }
    return hash;
}

//
// Template-table plugin for transparency
//
(function ($) {
    var slides = [];
    var methods = {
        init: function () {
            var c = Cookies.get('templateShown');
            // click-outside-detail handler
            $('body').on('click', function (e) {
                if (isViewNarrow()) {
                    // details shown in modal mode
                    if ($('.templateTarget.current').length) {
                        // there is a detail pane showing
                        if (!$(e.target).closest('.templateTarget').length && !$(e.target).closest('.templateLoad').length && !$(e.target).closest('.month-nav-control').length) {
                            // click outside any detail view, and also not itself a template-loader. 
                            // Also allow clicks on the month nav control (flip month to month with detail up).
                            e.preventDefault();
                            e.stopPropagation();
                            mainFullWidth();    // reset the view, dismissing any detail.
                            return false;
                        }
                    }
                }
            });
            // initial display of areas
            $('.templateDetailView').hide();
            $('.templateDetailView .templateTarget').hide();
            mainFullWidth();
            $('.transparencyLoading').hide();
            $('.transparencyTabs').show();
            $('#panelIDetail').show();
            $('#panelHDetail').show();
            $('.templatePane').find('.slide-nav').show();
            $('.templateMainView .templateLoad').click(function () {
                $('.templateLoad.selected').removeClass('selected');
                slides.length = 0;  // First clear the array, when clicked from the main panel.
                $(this).addClass('selected');
            });
            if (c) {
                slides.push(c);
                mainHalfWidth();
                // select somebody who might have been clicked to get here
                $('.templateMainView .templateLoad[data-template-load="' + c + '"]').first().addClass('selected');
                switchTarget($(this).closest('.templatePane'), c, '.templateNavWrap', false);   // pass the selector, not the jquery array
            }
            return this.each(function () {
                var $load = $(this).find('.templateLoad');
                $load.each(function () {
                    var $target = $(this).data('templateLoad') + '.templateTarget';
                    $(this).click(function () {
                        switchTarget($(this).closest('.templatePane'), $target, '.templateNavWrap', true);   // scope to current pane
                    });
                });
                // close-box handler
                $(this).find('.close').on('click', function (e) {
                    e.preventDefault();
                    mainFullWidth();    // roll back to initial state.
                    return false;
                });
                $(this).data('initialized', true);
            });
        },
        click: function() {

        },
        switchTo: function ($target) {
            switchTarget($(this), $target, '.templateNavWrap', true);
        }
    };

    var isViewNarrow = function () {
        return $(window).width() < 992;
    }

    var mainFullWidth = function () {
        $('.templateTarget.current').hide().removeClass('current');
        $('.templateDetailView').hide();
        $('.templateMainView').addClass('full'); //.css('width', '100%').css('margin-right', '0');
        $('.templateMainView').find('.selected').removeClass('selected');
        slides = [];    // kill the stack.
        Cookies.remove('templateShown', { path: '' });
    }

    var mainHalfWidth = function () {
        $('.templateDetailView').show();
        $('.templateMainView').removeClass('full'); //.css('width', 'auto').css('margin-right', '');    // unset
    }

    var switchTarget = function ($scope, $target, showSelector, push) {
        // generate Google Analytics event tracking
        if (window.gtag) {
            window.gtag('event', 'Clicks', { action: 'Transparency', label: 'switch-template' });
        } else {
            window._gaq && window._gaq.push(['_trackEvent', 'Clicks', 'Transparency', 'switch-template']);
        }
        mainHalfWidth();
        var $oldTemplate = $('.templateTarget.current');
        // don't do anything if target is already in place.
        if ($oldTemplate.is($target))
            return;
        if ($oldTemplate.length > 0) {
            $oldTemplate.removeClass('current');
            if ($(window).width() > 922) {
                $oldTemplate.animate({ left: '-100%' }, function () {
                    $(this).hide();
                });
            } else {
                $oldTemplate.hide();
            }
            showTarget($scope, $target, '.templateNavWrap', push);
        } else {
            showTarget($scope, $target, '.templateNavWrap', push);
        }
    }

    var scrollIntoView = function (showSelector) {
        if ($(window).scrollTop() > $(showSelector).offset().top) {
            var offset = $(showSelector).offset();
            $('html, body').animate({
                scrollTop: offset.top - 20
            });
        }
    }

    var showTarget = function ($scope, $target, showSelector, push) {
        if (slides.length > 0) {
            $scope.find($target).find('.slide-nav').find('.back').removeClass('disabled').off('click').on('click', function (e) {
                e.preventDefault();
                slides.pop();
                if (slides.length > 0)
                    switchTarget($scope, slides.slice(-1)[0], showSelector, false);
                else
                    mainFullWidth();
            });
        } else {
            // no slides. Just go back to main view.
            $scope.find($target).find('.slide-nav').find('.back').removeClass('disabled').off('click').on('click', function (e) {
                e.preventDefault();
                mainFullWidth();
            });
            //$scope.find($target).find('.slide-nav').find('.back').addClass('disabled');
        }
        if (push)
            slides.push($target);
        // set time-limited cookie.
        var inFiveMinutes = new Date(new Date().getTime() + 5 * 60 * 1000);
        Cookies.set('templateShown', $target, { expires: inFiveMinutes, path: '' });
        var $newTemplate = $scope.find($target).first();
        $newTemplate.show();    // ...still offscreen
        // make sure height of parent is sufficient
        var heightNeeded = Math.max($newTemplate.outerHeight(true), $('.templateMainView').height());
        $newTemplate.closest('.templateDetailView').height(heightNeeded);
        // only perform animation on wide sizes
        $newTemplate.addClass('current');
        if (!isViewNarrow()) {
            // reset to offscreen-left, and a little bit further to give previous slide a head start, then animate on.
            $newTemplate.css('left', $newTemplate.outerWidth() + 10).animate({ left: 0 }, function () {
                scrollIntoView(showSelector);
            });
        } else {
            // just pop on.
            $newTemplate.css('left', 0);
            scrollIntoView(showSelector);
        }
    };

    $.fn.templateTable = function (method) {
        if (methods[method]) {
            // make ready for first use.
            if (!$(this).data('initialized'))
                methods.init.apply(this);
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            // unknown method.
            alert('Unknown method: ' + method.toString());
        }
    };
})(jQuery);

//
// Transparency tab plugin. Remember currently-selected tab; re-establish if there's one recorded.
//
//(function ($) {
//    $.fn.templateTabs = function (/* options */) {
//        return this.each(function () {
//            $(this).tabs();
//            $(this).find('.ui-tabs-anchor').click(function () {
//                Cookies.set('template_tab', $(this).attr('id'), { path: '/' });
//            });
//            var c = Cookies.get('template_tab');
//            if (c) {
//                $('#' + c).trigger('click');
//            }
//            $(this).show();
//        });
//    };
//})(jQuery);

//
// field-size plugin.
//
(function ($) {
    $.fn.fieldSize = function (/* options */) {
        return this.each(function () {
            let $this = $(this),
                size = $this.attr('size'),
                isize = _.toSafeInteger(size);

            if (isize) {
                if ($this.is('.form-control')) {
                    $this.css('width', (isize + 2) + 'rem');
                } else {
                    $this.css('width', (isize) + 'rem');
                }
            }
        });
    };

    $(document).ready(function () {
        $('input:text[size]').fieldSize();
    });
})(jQuery);

//
// c3 income chart plugin.
//
(function ($) {
    var initialized = false,
        chart = null;
    var c3 = require('c3'),
        d3 = require('d3'),
        _ = require('lodash'),
        parse = require('url-parse'),
        url = parse(window.location, true),
        printing = url.query.pj,
        spill = function () {
            //console.log('{' + r.x + ', ' + r.y + ', ' + r.width + ', ' + r.height + '}')
        },
        label = function (opts) {
            // accessible label
            // column names are in opts.data.columns[0], starting in column 1
            try {
                let totals = opts.total,
                    cols = _.take(_.clone(opts.data.columns[0]).slice(1), totals.length);   // truncate to length of the totals
                // column totals are in opts.total
                // zip them together
                let smoosh = _.zip(cols, opts.total); // [['Today', 500], ['Plan', 1000]]
                return _.join(_.map(smoosh, function (v) { return _.join(v, ': $'); }), '; ');
            } catch (ex) {
                // all kinds of things could go wrong
            }
            return 'Chart';
        },
        addons = function (cht, opts) {
            if (!initialized) {
                initialized = true;
                //console.log('flushing');
                _.delay(function () {
                    //chart.resize();
                    //console.log('...flushed.');
                }, 200);
                //return;
            }
            var bx = d3.selectAll('.c3-axis-x').node().getBBox(),
                by = d3.selectAll('.c3-axis-y').node().getBBox(),
                calloutOffset = opts.calloutOffset || { x: 0, y: -50 },
                calloutTop = by.y + calloutOffset.y;
            spill(bx);
            spill(by);

            d3.selectAll('#income_chart svg .callout-group').remove();
            var calloutGroup = d3.select('#income_chart svg > g')
                .append('g')
                .attr('class', 'callout-group');
            // console.log(url.query);
            // extend .scenario-current box upward
            d3.selectAll('.c3-regions .c3-region.scenario-current').each(function (/*d*/) {
                var box = this.getBBox();
                d3.select(this)
                    .append('rect')
                    .attr('x', box.x)
                    .attr('y', box.y - 200)
                    .attr('width', box.width)
                    .attr('height', 200);
            });
//            d3.selectAll('.c3-chart-bar.c3-target-Work-income path').each(function (d) {
            d3.selectAll('.c3-chart-bar.c3-target path').each(function (d) {
                // this = path node (each work income bar)
                var box = this.getBBox();
                spill(box);
                // console.log('data: ' + JSON.stringify(d));
                box.y -= 24;
                calloutGroup
                    .append('g')
                    .attr('x', box.x)
                    .attr('y', 0)
                    .attr('width', box.width)
                    .attr('height', 50)
                    .attr('class', 'extendo-box');

                calloutGroup
                    .append('rect')
                    .attr('x', box.x)
                    .attr('y', calloutTop)
                    .attr('width', box.width)
                    .attr('height', '24')
                    .attr('stroke', 'none')
                    .attr('fill', 'none');
                // link, unless we're in print-job
                let yStep = 16;
                if (printing) {
                    calloutGroup
                        .append('text')
                        .attr('class', 'chart-link disabled')
                        .attr('text-anchor', 'middle')
                        .attr('x', box.x + box.width / 2)
                        .attr('y', calloutTop + yStep)
                        .text(opts.data.columns[0][d.x + 1])
                        .style('fill', 'black');

                } else {
                    if (opts.url && opts.url[d.x]) {
                        // chart-link. Trying to emulate underscore treatment on body links.
                        let a = 
                            calloutGroup
                                .append('a')
                                .attr('xlink:href', opts.url[d.x])
                                .attr('class', 'chart-link'),
                            text = a
                                .append('text')
                                .attr('text-anchor', 'middle')
                                .attr('x', box.x + box.width / 2)
                                .attr('y', calloutTop + yStep)
                                .text(opts.data.columns[0][d.x + 1])
                                .style('fill', '#0050C6');
                        let textBox = text.node().getBBox();
                        spill(textBox);
                        a
                            .append('rect')
                            .attr('class', 'underscore')
                            .attr('x', textBox.x)
                            .attr('y', textBox.y + textBox.height + 2)
                            .attr('height', 0.5)
                            .attr('width', textBox.width);
                    } else {
                        // is there a subtitle?
                        let title = opts.data.columns[0][d.x + 1],
                            titles = title.split('\n');
                        if (titles.length > 1) {
                            _.each(titles, function (s) {
                                calloutGroup
                                .append('text')
                                .attr('class', 'chart-amount')
                                .attr('text-anchor', 'middle')
                                .attr('x', box.x + box.width / 2)
                                .attr('y', calloutTop + yStep)
                                .text(s)
                                .style('fill', 'black');
                                yStep += 20;
                            });
                            yStep -= 20; // back out the last one.
                        } else {
                            // simple case.
                            calloutGroup
                                .append('text')
                                .attr('class', 'chart-amount')
                                .attr('text-anchor', 'middle')
                                .attr('x', box.x + box.width / 2)
                                .attr('y', calloutTop + yStep)
                                .text(title)
                                .style('fill', 'black');
                        }
                        
                    }
                }
                // title
                yStep += 24;
                calloutGroup
                    .append('text')
                    .attr('text-anchor', 'middle')
                    .attr('x', box.x + box.width / 2)
                    .attr('y', calloutTop + yStep)
                    .attr('class', 'chart-title')
                    .text(d3.format('$,.2f')(opts.total[d.x]))
                    .style('fill', 'black');
                yStep += 8;
                // help landmark
                calloutGroup
                    .append('rect')
                    .attr('class', 'help-marker')
                    .attr('id', 'hx-' + d.x)
                    .attr('x', box.x + box.width / 2)
                    .attr('y', calloutTop + yStep)
                    .attr('height', 1)
                    .attr('width', 1)
                    .attr('fill', 'none');
            });
            if (opts.chartTitle) {
                calloutGroup
                    .append('text')
                    .attr('text-anchor', 'left')
                    .attr('x', 26)
                    .attr('y', calloutTop + 16)
                    .attr('class', 'chart-title chart-income-title')
                    .text(opts.chartTitle)
                    .style('fill', 'black');
            }
        };

    $.fn.c3IncomeChart = function (options) {
        let opts = _.extend(options, $.fn.c3IncomeChart.defaults, {});
        //console.log('c3IncomeChart: ' + JSON.stringify(opts));
        if (opts && opts.axis && opts.axis.y && opts.axis.y.tick)
            opts.axis.y.tick.format = d3.format('$,.2f');
        if (opts) {
            opts.tooltip = opts.tooltip || {};
            opts.tooltip.format = opts.tooltip.format || {};
            opts.tooltip.format.value = function (value) {
                let fmt = d3.format('$,.2f'); return fmt(value);
            }
        }

        // for print job, supply an explicit width
        if (printing) {
            opts.size = { width: 992, height: 462 };
            //console.log('setting explicit size: ' + JSON.stringify(opts));
        }
        opts.onrendered = function () {
            addons(this, opts);
            // some items guide on elements in the chart
            _.delay(function () { $('.move-me').efw$moveme(); }, 500);
        };

        return this.each(function () {
            let $this = $(this);

            chart = c3.generate(opts);

            // generate accessible label
            $this.attr('aria-label', label(opts));
            $this.find('svg').attr('aria-hidden', true);

            $(window).on('resize', null, _.throttle(function (/* e, arg */) {
                chart.destroy();
                chart = c3.generate(opts);
            }, 200, { leading: false, trailing: true }));
        });
    };

    $.fn.c3IncomeChart.defaults = {
        legend: {
            inset: {
                anchor: 'top-left',
                y: 20
            }
        }
    }
})(jQuery);

//
// Activate tab-navigation in Estimator results.
// 
(function ($) {
    $(document).ready(function () {
        $('.styleScenarioMenu a[data-toggle=tab]').on('show.bs.tab', function (e) {
            window.location.href = $(e.target).attr('href');
            return false;
        });
    })
})(jQuery);

//
// plugin to condition bootstrap4-toggle elements for accessibility.
// bootstrap4-toggle preceeds us in the load order
//
(function ($) {
    $.fn.bootstrapToggleFixup = function (/* options */) {
        // this = the checkbox that bootstrap4-toggle hid and wrapped in a div.toggle.
        // Keep the real checkbox as the one control (WCAG 4.1.2): it is named by its
        // form-group <label for>, takes one tab stop, and toggles with Space. The
        // wrapper is drawing only: no role="button", not focusable, Yes/No hidden from
        // assistive technology. Mouse clicks on the drawing still work (the library
        // handles clicks on the wrapper).
        return this.each(function () {
            let $this = $(this),
                $toggle = $this.closest('.toggle');

            $this.addClass('sr-only').css('display', 'inline-block');   // focusable, not visible
            $toggle.removeAttr('role').removeAttr('tabindex').off('keypress keydown keyup');
            $toggle.find('.toggle-group').attr('aria-hidden', 'true')
                .find('label').removeAttr('for');   // else the checkbox name reads "question Yes No"

            // The library's click handler on the wrapper calls preventDefault, which would
            // cancel the checkbox's own toggle when Space fires a click on it.
            $this.on('click', function (e) { e.stopPropagation(); });

            // Redraw the switch when the checkbox changes from the keyboard
            // (silent: do not fire change again).
            $this.on('change', function () {
                $(this).bootstrapToggle(this.checked ? 'on' : 'off', true);
            });
        });
    };

    $(document).ready(function () {
        $('input[data-toggle="toggle"]').bootstrapToggleFixup();
    });
})(jQuery);

//
// plugin to condition all /planning/ URLs for time-signature.
//
(function ($) {
    $.fn.signatureFixup = function (/* options */) {
        return this.each(function () {
            let $this = $(this),
                tagName = $this.prop('tagName').toLowerCase(),
                tags = {
                    form: 'action',
                    a: 'href'
                };

            Object.keys(tags).forEach((k) => {
                if (k == tagName) {
                    $this.attr(tags[k], $this.attr(tags[k]).replace(/-uuuu/g, '-' + new Date().getTime()));
                }
            });
        });
    };

    $(document).ready(function () {
        if (window.location.toString().includes('/planning/')) {
            $('a[href*="-uuuu"], form[action*="-uuuu"]').signatureFixup();
        }
    });
})(jQuery);
